<ssl-rating-preview
    [sslRating]="sslRating$ | async"
    [isSslRatingLoading]="isSslRatingLoading$ | async"
    [config]="config" 
></ssl-rating-preview>
